// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1WoHj","options":"AnswerScale_options__18stu","selected":"AnswerScale_selected__zo4Hq"};